import { render, staticRenderFns } from "./MasterPhraseEdit.vue?vue&type=template&id=10a62f30&scoped=true&lang=pug&"
import script from "./scripts/MasterPhraseEdit.js?vue&type=script&lang=js&"
export * from "./scripts/MasterPhraseEdit.js?vue&type=script&lang=js&"
import style0 from "./MasterPhraseEdit.vue?vue&type=style&index=0&id=10a62f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a62f30",
  null
  
)

export default component.exports